import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface DoorwayFrameProps extends Omit<BoxProps, 'children'> {
  src: string
  alt?: string
  caption?: React.ReactNode
  width?: number | string
}

const Root = styled(Box, {
  shouldForwardProp: (p) => p !== 'width',
})<{ width: number | string }>(({ width }) => ({
  position: 'relative',
  width,
  maxWidth: '70%',
  margin: '0 auto',
  aspectRatio: '3 / 3.4',
  borderRadius: '50% 50% 0 0 / 42% 42% 0 0',
  overflow: 'hidden',
  boxShadow: '0 -30px 90px rgba(190, 157, 253, 0.16)',
}))

const Img = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  opacity: 0.9,
  display: 'block',
})

const Caption = styled(Box)({
  position: 'absolute',
  left: '50%',
  bottom: 16,
  transform: 'translateX(-50%)',
  fontFamily: 'var(--ds-font-mono)',
  fontSize: 8,
  letterSpacing: '0.14em',
  color: '#fff',
  background: 'rgba(13, 13, 15, 0.6)',
  backdropFilter: 'blur(8px)',
  borderRadius: 'var(--ds-radius-pill)',
  padding: '6px 12px',
  whiteSpace: 'nowrap',
})

/** Arch-clipped "doorway" image — the brand's literal geometry motif for hero/finale moments. */
export function DoorwayFrame({ src, alt = '', caption, width = 300, ...rest }: DoorwayFrameProps) {
  return (
    <Root width={width} {...rest}>
      <Img src={src} alt={alt} />
      {caption && <Caption>{caption}</Caption>}
    </Root>
  )
}
